import { GIIN_SEGMENT_LENGTHS } from "./constants";

/**
 * Sanitizes a GIIN value by:
 * 1. Converting to uppercase
 * 2. Removing the letter 'O' (not allowed in GIIN)
 * 3. Keeping only alphanumeric characters
 */
export const sanitizeGiinValue = (value: string): string => {
  return value
    .toUpperCase()
    .replace(/O/g, "")
    .replace(/[^A-Z0-9]/g, "");
};

/**
 * Joins GIIN segments into a dot-separated string, trimming trailing empty segments.
 * e.g. ["ABC", "123", "", ""] -> "ABC.123"
 */
export const joinSegments = (segments: string[]): string => {
  let lastNonEmptyIndex = -1;
  for (let i = segments.length - 1; i >= 0; i--) {
    if (segments[i].length > 0) {
      lastNonEmptyIndex = i;
      break;
    }
  }
  if (lastNonEmptyIndex === -1) return "";
  return segments.slice(0, lastNonEmptyIndex + 1).join(".");
};

/**
 * Finds the index of the last non-empty segment.
 * Returns -1 if all segments are empty.
 */
export const findLastFilledIndex = (segments: string[]): number => {
  for (let i = segments.length - 1; i >= 0; i--) {
    if (segments[i].length > 0) return i;
  }
  return -1;
};

/**
 * Parses a raw GIIN string (or formatted) into segments based on GIIN_SEGMENT_LENGTHS.
 * e.g. "ABCDEF12345AB123" -> ["ABCDEF", "12345", "AB", "123"]
 */
export const parseGiinToSegments = (rawChars: string): string[] => {
  let currentPos = 0;
  return GIIN_SEGMENT_LENGTHS.map((len) => {
    const segment = rawChars.slice(currentPos, currentPos + len);
    currentPos += len;
    return segment;
  });
};
